import { AssetTypes } from 'src/app/shared/guards/asset-lock-guard';
import { AssetUnlockedNotification, NotificationContentBase } from '../../services/api.services';
import { BasicNotification } from '../models/basic-notification';

export function assetUnlockMapping(content: NotificationContentBase, time: string) {
  const data = content as AssetUnlockedNotification;
  return {
    id: data.id,
    iconUrl: getIconUrl(data.assetLockType),
    pendingUrl: getPendingIconUrl(data.assetLockType),
    color: '#6DD400',
    headline: getItemType(data.assetLockType) + ' Unlocked',
    panelHeadline: getItemType(data.assetLockType) + ' Unlocked',
    title: data.assetName,
    message: 'is now unlocked.',
    buttons: [
      {
        label: 'Edit',
        url: getEditUrl(data.id, data.assetLockType)
      }
    ],
    time
  } as BasicNotification;
}

function getIconUrl(assetLockType: string): string {
  switch (assetLockType) {
    case AssetTypes.Visual:
      return '/assets/img/notification-icons/pivot-unlocked.svg';

    case AssetTypes.Dashboard:
      return '/assets/img/notification-icons/dashboard-unlocked.svg';

    case AssetTypes.Schedule:
      return '/assets/img/notification-icons/schedule-unlocked.svg';

    case AssetTypes.PublishedReport:
      return '/assets/img/notification-icons/published-unlocked.svg';
  }
}

function getPendingIconUrl(assetLockType: string): string {
  switch (assetLockType) {
    case AssetTypes.Visual:
      return '/assets/img/notification-icons/pivot-grey.svg';

    case AssetTypes.Dashboard:
      return '/assets/img/notification-icons/dashboard-grey.svg';

    case AssetTypes.Schedule:
      return '/assets/img/notification-icons/schedule-grey.svg';

    case AssetTypes.PublishedReport:
      return '/assets/img/notification-icons/published-grey.svg';
  }
}

function getItemType(assetLockType: string): string {
  switch (assetLockType) {
    case AssetTypes.Visual:
      return 'Visual';

    case AssetTypes.Dashboard:
      return 'Dashboard';

    case AssetTypes.Schedule:
      return 'Schedule';

    case AssetTypes.PublishedReport:
      return 'Published Item';
  }
}

function getEditUrl(assetId: number, assetLockType: string): string {
  switch (assetLockType) {
    case AssetTypes.Visual:
      return `/visuals/${assetId}`;

    case AssetTypes.Dashboard:
      return `dashboards/${assetId}/edit`;

    case AssetTypes.Schedule:
      return `scheduler/${assetId}`;

    case AssetTypes.PublishedReport:
      return `enterprise-insights/${assetId}`;
  }
}
